import { HTMLAttributes, useMemo } from 'react'

export type Props = {
  className?: string
} & HTMLAttributes<HTMLDivElement>

const Container = ({ className, ...rest }: Props) => (
  <div
    className={useMemo(() => `hhg-page-container ${className}`, [className])}
    {...rest}
  />
)

export { Container }
